// OAuth settings
export const BASE_URL = global.env.BASE_URL;
export const OAUTH_CLIENT_ID = global.env.OAUTH_CLIENT_ID;
const HORIZON_CLIENT_ID = global.env.HORIZON_CLIENT_ID;
export const OAUTH_DOMAIN = global.env.OAUTH_DOMAIN;
export const OAUTH_AUDIENCE = global.env.OAUTH_AUDIENCE;
export const AUTH_URL = global.env.AUTH_URL;
export const AUTH_AMS_URL = global.env.AUTH_AMS_URL;
export const REGION_URLS = global.env.REGION_URLS;

// Logout URLs
export const LOGOUT_URL = global.env.LOGOUT_URL;
export const LOGOUT_URL_HORIZON = global.env.LOGOUT_URL_HORIZON;
export const LOGOUT_URL_KEYSTONE = global.env.LOGOUT_URL_KEYSTONE;
export const LOGOUT_URL_KEYSTONE_AMS2 = global.env.LOGOUT_URL_KEYSTONE_AMS2;

// Adyen settings
export const P1_PUB_KEY = global.env.P1_PUB_KEY;

// Stripe settings
export const P2_PUB_KEY = global.env.P2_PUB_KEY;

// Google Analytics
export const GA_CODE = global.env.GA_CODE;
